<script>
	import { isPortraitScreen, pageOffset, universalScroll, toggleUniversalToPageScroll } from '../js/model/stores';
	import { animateElement } from '../js/utils/animate';
	import Drop from "./Drop.svelte";

	let _drops;
	let _clouds;
	let _cloud_1;
	let _cloud_2;
	let portrait;

	let animation = (value) => {

		if (!$universalScroll) {
			//return;
		}

		animateElement(value, _clouds, (currentPageOffset) => {
			_clouds.style.transform = `translateX(${currentPageOffset * (portrait ? 0.05 : 0.1)}em)`;

			_cloud_1.style.opacity = (currentPageOffset > window.innerWidth * 0.2) ? 0 : 1;
			_cloud_2.style.opacity = (currentPageOffset > window.innerWidth * 0.3) ? 0 : 1;
			_drops.style.opacity = (currentPageOffset > window.innerWidth * (portrait ? 0.1 : 0.15)) ? 0 : 1;
		});
	};

	let prepareScene = () => {
		if (!_clouds) {
			requestAnimationFrame(prepareScene);
			return;
		}

		pageOffset.subscribe(animation);
		isPortraitScreen.subscribe((state) => {
			portrait = state;
		});
	};

	prepareScene();

</script>

<style>
	.cloud {
		position: absolute;
		left: 8em;
		top: 2em;
	}

	.cloud svg {
		width: auto;
		height: 4em;
	}

	.drops {
		position: relative;
		width: 100%;
		margin-top: 15%;
	}

	.cloud.portrait svg {
		width: auto;
		height: 3em;
	}

	.cloud.portrait {
		left: -1em;
	}

	.portrait .drops {
		margin-top: 5%;
	}
</style>

<div class:portrait class="cloud" bind:this={_clouds}>
	<svg width="180" height="78" viewBox="0 0 180 78" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path bind:this={_cloud_1} d="M129.768 38.5059H60.2859H19.4141C8.85556 38.5059 0 47.025 0 57.9294C0 68.4931 8.51496 77.353 19.4141 77.353H60.2859H129.768C140.327 77.353 149.182 68.8339 149.182 57.9294C149.182 47.025 140.327 38.5059 129.768 38.5059Z" fill="#5A97C3"/>
		<path bind:this={_cloud_2} d="M160.081 38.8472H90.5989C80.0404 38.8472 71.1848 30.3281 71.1848 19.4236C71.1848 8.51912 79.6998 0 90.5989 0H160.081C170.64 0 179.495 8.51912 179.495 19.4236C179.495 30.3281 170.64 38.8472 160.081 38.8472Z" fill="#5A97C3"/>
	</svg>
	<div class="drops" bind:this={_drops}>
		<Drop index="1" leftOffset="-25%" topOffset="30%" speedMultiplier="0.5"/>
		<Drop index="2" leftOffset="10%" topOffset="15%" speedMultiplier="0.5"/>
		<Drop index="3" leftOffset="0%" topOffset="30%" speedMultiplier="0.5"/>
		<Drop index="4" leftOffset="-15%" topOffset="15%" speedMultiplier="0.5"/>
	</div>
</div>
